import { IDisclaimerServiceMock } from "./disclaimer.types";

export const mockDisclaimerService = (): IDisclaimerServiceMock => ({
  getDisclaimerFile: jest.fn(),
});
